import React from 'react'
import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { Button, space, device, color } from '@ticketswap/solar'
import PartnerDialog from '~/components/PartnerDialog'
import PropTypes from 'prop-types'
import { Description, StyledCover, Title } from '~/components/BlobCover/styles'
import { NarrowPageLayout } from '~/components/PageLayout'
import { getLinkProps, track } from '~/utils'
import { PARTNER_DASHBOARD_CLICKED } from '~/lib/tracking-events'
import Link from 'next/link'
import { useViewer } from '~/components/ViewerContext'

const StyledPageLayout = styled(NarrowPageLayout)`
  z-index: 2;
  position: relative;
`

const StyledButton = styled(Button)`
  align-self: flex-end;
  z-index: 2;
  position: relative;
  margin: 0 auto;
  display: inline-flex;
  clear: both;
  ${({ type }) =>
    type !== 'default' &&
    css`
      background-color: rgb(0, 83, 111);
      background-image: none;

      &:hover {
        background-color: rgb(0, 102, 137);
      }
    `}

  ${({ type }) =>
    type === 'transformed' &&
    css`
      transform: translateY(40%);

      @media ${device.tablet} {
        padding: 16px 90px;
      }
    `}

   ${({ type }) =>
    type === 'bordered' &&
    css`
      @media ${device.tablet} {
        padding: 16px 90px;
      }

      &:before {
        content: '';
        position: absolute;
        width: calc(100% + ${space[16]});
        height: calc(100% + ${space[16]});
        top: -${space[8]};
        left: -${space[8]};
        border: ${space[8]} solid ${color.nova};
        pointer-events: none;
      }
    `}

     ${({ type }) =>
    type === undefined &&
    css`
      @media ${device.tablet} {
        padding: 16px 90px;
      }
    `}
`

export const BecomePartnerButton = ({ t, width, size, type, variant }) => {
  const { viewer } = useViewer()
  const { isPartner, isEmployee } = viewer || {}

  return (
    <>
      {isPartner && !isEmployee && (
        <StyledButton
          as="a"
          href="/organizers/dashboard"
          type={type}
          onClick={async () => {
            await track(PARTNER_DASHBOARD_CLICKED)
          }}
          variant={variant}
        >
          {t('partners:header.button.dashboard')}
        </StyledButton>
      )}
      {isPartner && isEmployee && (
        <Link {...getLinkProps('PARTNER_DASHBOARD')} passHref>
          <StyledButton
            as="a"
            type={type}
            onClick={async () => {
              await track(PARTNER_DASHBOARD_CLICKED)
            }}
            variant={variant}
          >
            {t('partners:header.button.dashboard')}
          </StyledButton>
        </Link>
      )}
      {!isPartner && (
        <PartnerDialog t={t}>
          {({ getToggleProps }) => (
            <StyledButton
              type={type}
              variant={variant}
              width={width}
              size={size}
              {...getToggleProps()}
            >
              {t('partners:header.button.becomePartner')}
            </StyledButton>
          )}
        </PartnerDialog>
      )}
    </>
  )
}
BecomePartnerButton.propTypes = {
  t: PropTypes.func.isRequired,
  width: PropTypes.string,
  size: PropTypes.string,
  type: PropTypes.string,
  variant: PropTypes.string,
}

export const PartnerCover = ({ t }) => {
  return (
    <StyledCover>
      <StyledPageLayout>
        <Title>{t('partners:header.title')}</Title>
        <Description>{t('partners:header.description')}</Description>
      </StyledPageLayout>
      <BecomePartnerButton type={'transformed'} t={t} />
    </StyledCover>
  )
}

PartnerCover.propTypes = {
  t: PropTypes.func.isRequired,
}
